import useSWRFetcher, { SWRFetchError } from "../commonly-stored/fetcher";
import { useCallback } from "react";
import useSWR from "swr";
import settings from "../../../constants/settings";
import { InventoryBin } from "../../../components/internal/parts/Bins/inventoryBinTypes";

export interface InventoryBinsResponse {
  bins: InventoryBin[];
}

export default function useGetAllInventoryBins() {
  const fetcher = useSWRFetcher<InventoryBinsResponse>();

  const {
    data: inventoryBinsResponse,
    mutate,
    error,
  } = useSWR<InventoryBinsResponse, SWRFetchError>(
    `${settings.api_url}/inventory/bins/all`,
    fetcher,
  );

  const refreshBins = useCallback(() => {
    void mutate();
  }, [mutate]);

  return {
    inventoryBinsResponse: inventoryBinsResponse || null,
    errored: error !== undefined,
    refreshBins,
  };
}
